export default "__VITE_ASSET__D8Fq7aIr__"